
import React, { useEffect, useState } from "react";
import { useNotification } from "../../../contexts/NotificationContext";

const GlobalNotification = () => {
  const { notification } = useNotification();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (notification) {
      setShow(true);

      // Hide after 3 seconds
      setTimeout(() => {
        setShow(false);
      }, 3000);
    }
  }, [notification]);

  if (!notification || !show) return null;

  const baseClasses = "fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded shadow-md text-white text-center z-50 transition-all duration-300";
  const typeClasses = notification.type === "success"
    ? "bg-green-500"
    : "bg-red-500";

  const slideInClasses = "animate-slideDown";
  const fadeOutClasses = "animate-fadeOut";

  return (
    <div
      className={`${baseClasses} ${typeClasses} ${show ? slideInClasses : fadeOutClasses}`}
    >
      {notification.message}
    </div>
  );
};

export default GlobalNotification;
